import { styled } from "styled-components";

export const OptionContainer = styled.div`
  display: flex;
  margin-top: 12px;
  gap: 18px;
  height: 30px;
  & > * {
    flex: 1;
  }
`;
